import { compose } from "recompose";

import { protectedComponentHoc } from "../../components/ProtectedComponent";
import { CountriesComponent } from "./component";

export const Countries = compose(protectedComponentHoc)(CountriesComponent);
